export const wrapperStyles = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'flex-start',
  gap: 1,
  padding: '2px 8px 2px 8px',
  position: 'relative',
  width: '100%',
  '&:hover': {
    backgroundColor: 'action.hover',
  },
};

export const groupedWrapperStyles = {
  ...wrapperStyles,
  paddingTop: '1px',
  paddingBottom: '1px',
};

export const avatarColumnStyles = {
  flexShrink: 0,
  width: 36,
  display: 'flex',
  justifyContent: 'center',
  paddingTop: '2px',
};

export const gutterTimestampStyles = {
  flexShrink: 0,
  width: 36,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  paddingTop: '2px',
  color: 'text.secondary',
  visibility: 'hidden',
  '.teamChatMessageRow:hover &': {
    visibility: 'visible',
  },
};

export const rootStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: 0.25,
  flex: 1,
  minWidth: 0,
};

export const headerStyles = {
  display: 'flex',
  alignItems: 'baseline',
  gap: 1,
  flexWrap: 'wrap',
  marginBottom: '2px',
};

export const mentionStyles = {
  color: 'primary.main',
  backgroundColor: 'primary.light',
  borderRadius: '3px',
  padding: '0 3px',
};

export const timestampStyles = {
  color: 'text.secondary',
};

export const editedMarkerStyles = {
  color: 'text.secondary',
  fontStyle: 'italic',
  marginLeft: '4px',
};

export const actionsStyles = {
  position: 'absolute',
  top: '-12px',
  right: '12px',
  display: 'none',
  alignItems: 'center',
  gap: 0.25,
  padding: '2px',
  borderRadius: '6px',
  border: '1px solid',
  borderColor: 'divider',
  backgroundColor: 'background.paper',
  boxShadow: theme => theme.shadows[2],
  zIndex: 1,
  '.teamChatMessageRow:hover &': {
    display: 'inline-flex',
  },
};

export const actionButtonStyles = {
  padding: '4px',
  fontSize: '16px',
};

export const editFieldStyles = {
  width: '100%',
  marginTop: 0.5,
};

export const editActionsStyles = {
  display: 'flex',
  justifyContent: 'flex-end',
  gap: 1,
  marginTop: 0.5,
};

export const highlightedStyles = {
  backgroundColor: 'primary.light',
  transition: 'background-color 300ms ease',
  '@media (prefers-reduced-motion: reduce)': {
    transition: 'none',
  },
};
